/**
 * @author xiaohuangmaoth
 * @description 在线课程完成率
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

const _getValue = (type, key) => {
  const values = {
    status: {
          0 : '草稿',
          1 : '发布',
          2 : '关闭'
      },
  }
  return values[type][key] || ''
}

class CourseLearningStatistics extends WizContainer {
  componentName = "CourseLearningStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        rate: val.rate + '%',
        passRate: val.passRate + '%',
        status: _getValue('status',val.status)
      }))

      const title = '在线课程完成率'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true
      
    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(CourseLearningStatistics);
